// JavaScript Document
import React from 'react';
//import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function ErrorHandler(props) {
  const classes = useStyles();
  const {errorOpen, setErrorOpen, error, successOpen, setSuccessOpen, message} = props;
  //const [open, setOpen] = React.useState(false);

  //const handleClick = () => {
   // setErrorOpen(true);
  //};
  //const handleError = () => {
//	  setErrorOpen(true);
  //}

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessOpen(false);
    setErrorOpen(false);
  };

  return (
    <div className={classes.root}>
      <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          Error {error.code}: {error.message}
        </Alert>
      </Snackbar>
	  <Snackbar open={successOpen} autoHideDuration={3000} onClose={handleClose}>
	    <Alert onClose={handleClose} severity="success">
	      {message}
	    </Alert>
	  </Snackbar>
    </div>
  );
}
